module.exports = __webpack_public_path__ + "static/media/no-sys-message.fc699c63.png";